require('./helpers/bundle-manifest').register(JSON.parse("{\"jz5NA\":\"index.1ce7a371.js\",\"55V81\":\"selfoss-sw-offline.js\"}"));